// extracted by mini-css-extract-plugin
export var container = "Ripple-module--container--3e6vT";
export var ripple = "Ripple-module--ripple--1dweV";